const cookieJS = require("@/cookie.js");
const cookie = cookieJS.getCookie();
module.exports.init = async () => {
    if (!cookie) {
        let name = 'banhji-counter-token' + process.env.VUE_APP_MODE
        document.cookie = name+'=; Max-Age=-99999999;';
    }
}